import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.auth;

export const needToChangeTempPassword = createSelector([baseState], state => {
    return state.temp_password && !!state.token;
});
export const needToCompleteOnboarding = createSelector([baseState], state => {
    return !state.onboarding_done;
});
export const isLoggedIn = createSelector([baseState], state => {
    return !!state.token;
});

export const loginRedirectCheckData = createSelector([baseState, needToChangeTempPassword, needToCompleteOnboarding, isLoggedIn], (state, need_temp_password, need_onboarding, is_logged_in) => {
    return {
        isLoggedIn: is_logged_in,
        hasTempPassword: need_temp_password,
        hasDoneOnboarding: !need_onboarding,
        loaded: state.loaded
    }
});